
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.381 16.806a.876.876 0 01-1.237 1.237L.1 10l8.043-8.043A.876.876 0 019.38 3.194L3.45 9.126h15.212a.874.874 0 11-.001 1.75l-15.21-.001 5.93 5.93z","fill":"#7D7D7D","fill-rule":"evenodd"}})])
          )
        }
      }
    